export const ASYNC_CALL = 'ASYNC_CALL';
export const COMPANY_DATA = 'COMPANY_DATA';
export const CATEGORY_DATA = 'CATEGORY_DATA';
export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART'; 
export const CLEAR_CART = 'CLEAR_CART';
export const ADD_ALL = 'ADD_ALL';
export const REMOVE_BY_INDEX = 'REMOVE_BY_INDEX';
